import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";

function SicknessSummary() {
  // Initialiser avec l'année en cours
  const [year, setYear] = useState(new Date().getFullYear());
  const [summary, setSummary] = useState([]);

  // Récupère le résumé chaque fois que l'année change
  useEffect(() => {
    async function fetchSummary() {
      try {
        const response = await axios.get(`/api/sickness-summary/${year}`);
        setSummary(response.data);
      } catch (error) {
        toast.error("Failed to fetch sickness summary");
      }
    }
    fetchSummary();
  }, [year]);

  // Met à jour l'année en fonction de la saisie utilisateur
  const handleYearChange = (e) => {
    setYear(e.target.value);
  };

  // Helper pour formater la date en dd/mm/yyyy (si besoin d'affichage complémentaire)
  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return `${String(d.getDate()).padStart(2, "0")}/${String(
      d.getMonth() + 1
    ).padStart(2, "0")}/${d.getFullYear()}`;
  };

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">Sickness Summary for {year}</h1>
      <div className="mb-4">
        <label className="block text-gray-700 mb-1">Select Year:</label>
        <input
          type="number"
          value={year}
          onChange={handleYearChange}
          className="border px-2 py-1 rounded"
        />
      </div>
      <table className="min-w-full bg-white border border-gray-300 rounded-lg shadow-md">
        <thead>
          <tr>
            <th className="px-4 py-2">Rank</th>
            <th className="px-4 py-2">User</th>
            <th className="px-4 py-2">Total Sick Days (Mon-Thu)</th>
          </tr>
        </thead>
        <tbody>
          {summary.map((user, index) => (
            <tr key={user.user_id} className="border-t">
              <td className="px-4 py-2">{index + 1}</td>
              <td className="px-4 py-2">
                {user.firstName} {user.lastName}
              </td>
              <td className="px-4 py-2">{user.totalSickDays}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default SicknessSummary;
